import { Component, h, Prop, Element } from '@stencil/core';

@Component({
  tag: 'uui-tooltip',
  styleUrl: 'uui-tooltip.css',
  shadow: true
})
export class UUITooltip {
  @Element() element: HTMLElement;

  @Prop() text: string = '';
  @Prop() width: string = '120px';
  @Prop() position: 'top' | 'bottom' | 'left' | 'right' = 'top';

  componentDidLoad() {
    if (this.position === 'right' || this.position === 'left') {
      const inputElement =
        this.position === 'right'
          ? (this.element.shadowRoot.querySelector(
              '.tooltip .tooltiptext-right'
            ) as HTMLElement)
          : (this.element.shadowRoot.querySelector(
              '.tooltip .tooltiptext-left'
            ) as HTMLElement);
      const slotElement = this.element.shadowRoot.querySelector(
        '.tooltip .slot-div'
      ) as HTMLElement;
      inputElement.style.top = `${slotElement.offsetHeight / 2 -
        inputElement.offsetHeight / 2}px`;
    }
  }

  componentDidUpdate() {
    if (this.position === 'right' || this.position === 'left') {
      const inputElement =
        this.position === 'right'
          ? (this.element.shadowRoot.querySelector(
              '.tooltiptext'
            ) as HTMLElement)
          : (this.element.shadowRoot.querySelector(
              '.tooltiptext'
            ) as HTMLElement);
      const slotElement = this.element.shadowRoot.querySelector(
        '.tooltip .slot-div'
      ) as HTMLElement;
      inputElement.style.top = `${slotElement.offsetHeight / 2 -
        inputElement.offsetHeight / 2}px`;
    }
  }

  render() {
    const style = {
      width: this.width,
      'margin-left':
        this.position === 'right'
          ? '0px'
          : `-${parseInt(this.width.replace('px', '')) / 2}px`
    };

    const tooltipClass = `tooltiptext tooltiptext-${this.position}`;

    return (
      <div class={`tooltip default`}>
        <span class={tooltipClass} style={style}>
          {this.text}
        </span>
        <div class="slot-div">
          <slot />
        </div>
      </div>
    );
  }
}
